/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */
import React, {Component} from 'react';
import Svg from '../../../../../widgets/Svg/Svg';
import urlHelper from "../../../../../../_helpers/url.format.server.helper";
import config from "../../../../../../config";
import AxiosClient from "../../../../../../_helpers/http.helper";
import Om3pModalContainer from "../../OM3PComponents/OmModalContainer";
import {PERMISSIONS} from "../../../../../constants/constants";

export default class TableItems extends Component {

    constructor(props) {
        super(props);
        this.state = {
            showOm3pModal: false
        };

    }

    showOm3pModal = () => {

        this.setState({showOm3pModal: true});

    };

    hideOm3pModal = () => {

        this.setState({showOm3pModal: false});

    };


    render() {
        const { resourceData } = this.props;
        const resourcesData = resourceData.filter(resource => {

            return resource.resourceId === this.props.resourceIn.resource;

        });

        const relevantResource = resourcesData[0];

        const createNewPart = (sequence, chapterId) => {
            const payload = {
                "chapterId": chapterId,
                "createAfter": sequence
            };

            const deleteChapterResourcesUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.createNewPart,
                {
                    collectionId: this.props.collectionId,
                }

            );

            AxiosClient.post(deleteChapterResourcesUrl, payload)
                .then(() => {

                    this.props.loadCollection(this.props.collectionId);
                });

            this.props.freezeUi(true);
        };

        const deleteResource = (resource =>{

            const deleteChapterResourcesUrl = urlHelper.formatUrl(
                config.collectionService.baseUrl,
                config.collectionService.routes.deleteResource,
                {
                    collectionId: this.props.collectionId,
                }

            );

            const payload = {
                resourceIds: [resource.resourceId]
            };

            AxiosClient.delete(deleteChapterResourcesUrl,{data: payload})
                .then(() => {

                    this.props.loadCollection(this.props.collectionId);
                });

            this.props.freezeUi(true);

        });

        return (
            <div>
                {
                    relevantResource ?

                        <div className={"table-body" + (relevantResource.sharing === "Private" ? ' disable' : '')}>
                            {/*<div className='index cell'></div>*/}
                            <div className='index cell'>{this.props.index + 1}</div>
                            {relevantResource.sharing === "Private" ?
                                <div className='table-col cell' >{relevantResource.title} <br></br><span className={"retired"}><b>Retired Content</b></span></div> :
                                <div className='table-col cell'>{relevantResource.pearsonResourceType === "OM" && !this.props.permissions.includes(PERMISSIONS.view_only_om_title) ?
                                    <a className="omTitleLink" onClick={this.showOm3pModal}>
                                        {relevantResource.title}</a> : relevantResource.title}</div>}
                            <div className='table-col cell dots'>{relevantResource.fileName}</div>
                            <div className='table-col cell'>{relevantResource.authors}</div>
                            <div className='table-col cell'>{relevantResource.publisherName}</div>
                            <div className='table-col cell'>{relevantResource.parentISBN}</div>
                            <div className='table-col cell'>{relevantResource.price}</div>
                            {
                                this.props.permissions.includes(PERMISSIONS.view_only_delete_chapter) ?
                                    <div className='cell svg'  style={{cursor: 'default'}}>
                                        <span>
                                            <Svg svgString={'delete-18'} style={{fill: 'lightGrey'}}></Svg>
                                        </span>
                                    </div>
                                    :
                                    <div className='cell svg' onClick={(e) => {deleteResource(relevantResource);}}>
                                        <span>
                                            <Svg svgString={'delete-18'}></Svg>
                                        </span>
                                    </div>
                            }
                        </div>

                        : false
                }

                {this.props.resourceIn.sequence < this.props.length-1 && !this.props.permissions.includes(PERMISSIONS.hide_adding_part) && <div className="create-part-option-holder">
                    <div className="button-wrapper">
                        <div className="button-wrapper-child">
                            <button className="create-part-btn" onClick={() => {
                                createNewPart(this.props.resourceIn.sequence, this.props.chapterId);
                            }}>+ Part
                            </button>
                        </div>
                    </div>
                </div>
                }

                {
                    this.state.showOm3pModal && <Om3pModalContainer
                        showModal={this.state.showOm3pModal}
                        onCancel={this.hideOm3pModal}
                        activeCollection = {this.props.activeCollection}
                        chapterId={this.props.chapterId}
                        loadCollection = {this.props.loadCollection}
                        editModal={true}
                        resourceId = {relevantResource.resourceId}
                        resourceData = {relevantResource}
                    />
                }

            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/components/pages/BookContainer/ComponentPageComponents/ChapterComponents/HelperMethods/TableItems.js